export default class miniEffectManager {
    constructor() {

    }

    useText($target,type,param){

        if(type==="set"){
            let text = new SplitText(".js__use-text .text", {type: "words,chars"}),
                chars = text.chars;
            TweenMax.set(chars, {y: '100%'});
            TweenMax.set(".js__use-text .object01", {height: 0});
            TweenMax.set(".js__use-text .object02", {height: 0});
        }else{
            let _height = (param.displayType === 'pc')?78:35;
            TweenMax.to($target[0].querySelector(".object01"), .38, {
                height: _height, ease: Power1.easeOut
            });
            TweenMax.to($target[0].querySelector(".object02"), .38, {
                delay: .38, height: _height, ease: Power1.easeOut
            });
            TweenMax.staggerTo($target[0].querySelectorAll('.text>*>*'), 1.0,{
                y: '0%', ease: Power3.easeOut
            }, 0.03);
        }

    }

    objectFade($target,type){

        if(type==="set"){
            TweenMax.set(".js__object-fade.top", {opacity: 0, y: '-50px'});
            TweenMax.set(".js__object-fade.bottom", {opacity: 0, y: '50px'});
            TweenMax.set(".js__object-fade.right", {opacity: 0, x: '50px'});
            TweenMax.set(".js__object-fade.left", {opacity: 0, x: '-50px'});
        }else{
            TweenMax.to($target, 1.98, {
                opacity: 1, x: 0, y: 0, ease: Power2.easeOut,
            });
        }

    }

    compact(type){

        if(type==="set"){
            TweenMax.set('#concept-block02 .image01 .image',{ opacity: 0});
            TweenMax.set('#concept-block02 .image02 .image',{ opacity: 0, scale: 1.222});
            TweenMax.set('#concept-block02 .image02 .line',{ height: 0});
            TweenMax.set('#concept-block02 .image01 span',{ opacity: 0, x: 20});
            TweenMax.set('#concept-block02 .image02 span',{ opacity: 0, x: -20});
        }else{
            let tweenConcept = new TimelineMax();
            tweenConcept
            .to('#concept-block02 .image', .75, {opacity: 1,ease: Power3.easeInOut})
            .to('#concept-block02 .image02 .image', 1, {scale: 1,ease: Power1.easeInOut})
            .to('#concept-block02 .image02 .line', 1, {height: 600,ease: Power1.easeInOut})
            .to('#concept-block02 .image01 span', .5, {opacity: 1, x:0 ,ease: Power0.easeNone}, '-=.75')
            .to('#concept-block02 .image02 span', .5, {opacity: 1, x:0 ,ease: Power0.easeNone}, '-=.25');
        }

    }


}
